import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

export type Location = { location: { pathname: string } };

export type Props = {
    title?: string | null,
    description?: string | null,
    image?: string | null,
    pathName?: string | null
};

const Seo = ({ title, description, image, pathName }: Props) => {
    const { site } = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    siteUrl
                }
            }
        }
    `);

    console.log('SEO Data:', site);

    const { title: siteTitle, description: siteDescription, siteUrl } = site?.siteMetadata ?? {};

    const metaTitle = title ?? siteTitle;
    const metaDescription = description ?? siteDescription;
    const metaImage = image ?? `${siteUrl}/favicon.svg`;
    const metaURL = pathName ?? siteUrl;

    console.log('SEO component props:', metaTitle, metaDescription, metaImage, metaURL);

    return (
        <>
            {
                metaTitle &&
                <>
                    <title>{metaTitle}</title>
                    <meta name="title" content={metaTitle} />
                    <meta name="og:title" content={metaTitle} />
                    <meta name='og:site_name' content={metaTitle} />
                </>
            }
            {
                metaDescription &&
                <>
                    <meta name="description" content={metaDescription} />
                    <meta name="og:description" content={metaDescription} />
                </>
            }
            {
                metaImage &&
                <>
                    <meta name="image" content={metaImage} />
                    <meta name="og:image" content={metaImage} />
                </>
            }
            {
                metaURL &&
                <>
                    <meta name="url" content={metaURL} />
                    <meta name='og:url' content={metaURL} />
                </>
            }
            <meta name='og:type' content='website' />
        </>
    );

};

export default Seo;